import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import { Swiper } from 'swiper/types';
import { SignUpStore, useSignUpStore } from '@/stores/signup-store';
import { useToast } from '@/composables/useToast';

export const useSignUp = () => {
  const signUpStore: SignUpStore = useSignUpStore();

  const { signUpForm } = storeToRefs(signUpStore);
  const { showToast } = useToast();

  const loading = ref(false);
  const signUpSuccess = ref(false);
  const swiperSignUp = ref<Swiper>();

  const handleSignUp = async () => {
    try {
      loading.value = true;
      const response = await signUpStore.signUp();

      if (response) {
        signUpSuccess.value = true;
        await showToast(response);
        return response;
      }
      await showToast(response);
    } catch (error: unknown) {
      signUpSuccess.value = false;
      await showToast(error instanceof Error ? error.message : 'Unknown error', 'error');
    } finally {
      loading.value = false;
    }
  };

  const handleVerifyToken = async (token: string) => {
    try {
      loading.value = true;
      const response = await signUpStore.verifyToken(token);

      if (response) {
        signUpSuccess.value = true;
        await showToast(response);
        return response;
      }
      await showToast(response);
    } catch (error: unknown) {
      signUpSuccess.value = false;
      await showToast(error instanceof Error ? error.message : 'Unknown error', 'error');
    } finally {
      loading.value = false;
    }
  };

  const handleVerifyPasswordToken = async (token: string) => {
    try {
      loading.value = true;
      const response = await signUpStore.verifyPasswordToken(token);

      if (response) {
        signUpSuccess.value = true;
        await showToast(response);
        return response;
      }
      await showToast(response);
    } catch (error: unknown) {
      signUpSuccess.value = false;
      await showToast(error instanceof Error ? error.message : 'Unknown error', 'error');
    } finally {
      loading.value = false;
    }
  };

  return {
    signUpForm,
    loading,
    swiperSignUp,
    signUpSuccess,
    handleSignUp,
    handleVerifyToken,
    handleVerifyPasswordToken,
    clearLoginForm: signUpStore.clearLoginForm,
  };
};
